import PropTypes from 'prop-types'
import Link from 'next/link'
import * as Page from 'components/page'
import { Sorting } from 'components/button'
import { FlexContentCell } from 'components/table'
import PaginationComponent from 'components/pagination'
import * as Scroll from '@avcan/utils/dom/scroll'
import { FormattedMessage } from 'react-intl'

Header.propTypes = {
    columns: PropTypes.array.isRequired,
    sorting: PropTypes.array,
    place: PropTypes.object,
    onSortingChange: PropTypes.func.isRequired,
}

export function Header(props) {
    const { columns, sorting, onSortingChange } = props
    function getSorting(name, order) {
        if (Array.isArray(sorting) && sorting[0] === name) {
            return sorting[1]
        }

        return order
    }

    return (
        <thead>
            <tr>
                {columns.map(({ title, name, property, sorting, ...header }) => (
                    <FlexContentCell key={name} {...header}>
                        {typeof title === 'function' ? title(props) : title}
                        {sorting && (
                            <Sorting
                                onChange={onSortingChange.bind(null, name)}
                                sorting={getSorting(name, sorting)}
                            />
                        )}
                    </FlexContentCell>
                ))}
            </tr>
        </thead>
    )
}

Title.propTypes = {
    type: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
}

export function Title({ type, count, total }) {
    const pluralized = pluralize(type, 2)
    const all = 'All ' + pluralized
    const title = total === 0 ? all : `${all} (${total})`

    return (
        <>
            {title}
            {count !== total ? (
                <small>
                    <FormattedMessage
                        description="Layout ast/tables/utils"
                        defaultMessage="Currently showing {items}, <link>reset your criteria</link>."
                        values={{
                            items: pluralize(type, count, true),
                            link(text) {
                                return (
                                    <Link href={'/training/' + pluralized} scroll={false}>
                                        <a>{text}</a>
                                    </Link>
                                )
                            },
                        }}
                    />
                </small>
            ) : null}
        </>
    )
}

Layout.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
}

export function Layout({ title, children }) {
    return (
        <Page.Article>
            <Page.Header title={title} />
            {children}
        </Page.Article>
    )
}

Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number,
    count: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
}

export function Pagination({ page, count, pageSize = 25, onChange }) {
    if (count < 2) {
        return null
    }

    const total = Math.ceil(count / pageSize)

    function handleChange(page) {
        Scroll.scrollToContent()

        onChange(page)
    }

    return <PaginationComponent total={total} active={page} onChange={handleChange} />
}

// Utils
// TODO Remove that function as it is handle by Intl
function pluralize(word, count, inclusive) {
    const pluralized = count === 1 ? word : `${word}s`

    return inclusive ? `${count} ${pluralized}` : pluralized
}
